// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"_39dHWe","menuLink":"_1r4YjV","svg":"_3sg7E5","image":"FOiaoj","textMark":"_3rxxZ9"};